export default "__VITE_ASSET__Dnc7jCx5__"